import { render, staticRenderFns } from "./CoordinatorRequests.vue?vue&type=template&id=1b80a68e&scoped=true&"
import script from "./CoordinatorRequests.vue?vue&type=script&lang=js&"
export * from "./CoordinatorRequests.vue?vue&type=script&lang=js&"
import style0 from "./CoordinatorRequests.vue?vue&type=style&index=0&id=1b80a68e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b80a68e",
  null
  
)

export default component.exports